import { motion } from "framer-motion";
import { FiMapPin, FiPhone, FiMail, FiArrowUpRight } from "react-icons/fi";

// Animation variants
const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { 
    opacity: 1, 
    y: 0, 
    transition: { duration: 0.6, ease: "easeOut" } 
  }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2
    }
  }
};

const scaleOnHover = {
  whileHover: { 
    scale: 1.02,
    transition: { duration: 0.2 }
  }
};

const HelpDeskSection = () => {
const helpDesk = [
  {
    name: "Gautam Sengupta",
    phone: "+91 9999311483",
    email: "gautam.sengupta@assocham.com",
    role: " Deputy Director",
  },
    {
    name: "Sunita Dobhal",
    phone: "+91 9818325433",
    email: "sunita.dobhal@assocham.com",
    role: "Assistant Director",
  },
  {
    name: "Hrithik Verma",
    phone: "+91 7838981998",
    email: "hrithik.verma@assocham.com",
    role: "Senior Executive",
  },
    {
    name: "Nusrat Wajahat",
    phone: "+91 9868906133",
    email: "nusrat.wajahat@assocham.com",
    role: "Senior Executive",
  },
];

  return (
    <motion.section 
      id="helpdesk" 
      className="bg-white py-24 sm:py-32 overflow-hidden"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.8 }}
    >
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
        <div className="grid gap-16 lg:grid-cols-[0.9fr_1.1fr]">
          {/* Left Column - Header & Info */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
            variants={staggerContainer}
          >
            <motion.div 
              variants={fadeInUp}
              className="mb-4 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] text-[#DA2128]"
            >
              <motion.span 
                className="h-px w-8 bg-[#DA2128]"
                initial={{ width: 0 }}
                whileInView={{ width: 32 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.2 }}
              />
            </motion.div>

            <motion.h2 
              variants={fadeInUp}
              className="font-serif text-4xl font-medium leading-tight tracking-tight sm:text-3xl lg:text-4xl"
            >
              Help {" "}
              <motion.span 
                className="italic text-[#DA2128]"
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
                Desk
              </motion.span>
            </motion.h2>

            <motion.p 
              variants={fadeInUp}
              className="mt-6 max-w-md text-base leading-relaxed text-[#6B6B6B] sm:text-lg"
            >
              Our membership team is here to guide you to the right category and answer every question along the way.
            </motion.p>

            <motion.div 
              variants={fadeInUp}
              className="mt-10 space-y-4"
            >
              {/* Visit Us Card */}
              <motion.div 
                whileHover={{ 
                  scale: 1.02,
                  boxShadow: "0 8px 30px rgba(218, 33, 40, 0.12)",
                  borderColor: "rgba(218, 33, 40, 0.3)"
                }}
                transition={{ duration: 0.2 }}
                className="flex items-center gap-4 rounded-2xl border border-black/5 bg-[#FAF7F2] p-5 cursor-pointer"
              >
                <motion.div 
                  className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#DA2128]/10 text-[#DA2128]"
                  whileHover={{ 
                    rotate: [0, -10, 10, -5, 5, 0],
                    transition: { duration: 0.5 }
                  }}
                >
                  <FiMapPin className="text-xl" />
                </motion.div>
                <div>
                  <div className="text-xs font-bold uppercase tracking-wider text-[#6B6B6B]">Assocham HQ</div>
                  <div className="text-sm font-medium">4th Floor, YMCA Cultural Centre and Library Building, 01, Jai Singh Road, New Delhi - 110001</div>
                </div>
              </motion.div>

              {/* Call Us Card */}
              <motion.div 
                whileHover={{ 
                  scale: 1.02,
                  boxShadow: "0 8px 30px rgba(218, 33, 40, 0.12)",
                  borderColor: "rgba(218, 33, 40, 0.3)"
                }}
                transition={{ duration: 0.2 }}
                className="flex items-center gap-4 rounded-2xl border border-black/5 bg-[#FAF7F2] p-5 cursor-pointer"
              >
                <motion.div 
                  className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#DA2128]/10 text-[#DA2128]"
                  whileHover={{ 
                    rotate: [0, -10, 10, -5, 5, 0],
                    transition: { duration: 0.5 }
                  }}
                >
                  <FiPhone className="text-xl" />
                </motion.div>
                <div>
                  <div className="text-xs font-bold uppercase tracking-wider text-[#6B6B6B]">Call us</div>
                  <motion.div 
                    className="text-sm font-medium"
                    whileHover={{ scale: 1.05, color: "#DA2128" }}
                    transition={{ duration: 0.2 }}
                  >
                    +91 11 46550555
                  </motion.div>
                </div>
              </motion.div>
            </motion.div>
          </motion.div>

          {/* Right Column - Help Desk Cards */}
          <motion.div 
            className="grid gap-4 sm:grid-cols-2"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
            variants={staggerContainer}
          >
            {helpDesk.map((person, index) => (
              <motion.div
                key={person.name}
                variants={fadeInUp}
                whileHover={{ 
                  scale: 1.03,
                  boxShadow: "0 12px 40px rgba(218, 33, 40, 0.10)",
                  borderColor: "rgba(218, 33, 40, 0.3)",
                  transition: { duration: 0.2 }
                }}
                className="group rounded-2xl border border-black/5 bg-[#FAF7F2] p-6 transition hover:border-[#DA2128]/30 hover:bg-white hover:shadow-lg hover:shadow-[#DA2128]/5"
              >
                {/* <div className="mb-5 flex items-start justify-between">
                  <motion.div 
                    className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-[#DA2128] to-[#E54F15] font-serif text-lg font-bold text-white"
                    whileHover={{ 
                      rotate: [0, -15, 15, -10, 10, 0],
                      scale: 1.1,
                      transition: { duration: 0.5 }
                    }}
                  >
                    {person.name.split(" ").map((n) => n[0]).join("")}
                  </motion.div>
                  <motion.div
                    whileHover={{ 
                      rotate: 45,
                      color: "#DA2128",
                      transition: { duration: 0.3 }
                    }}
                  >
                    <FiArrowUpRight className="text-[#6B6B6B] transition-transform group-hover:rotate-45 group-hover:text-[#DA2128]" />
                  </motion.div>
                </div> */}

                <motion.h3 
                  className="font-serif text-lg font-semibold"
                  whileHover={{ color: "#DA2128" }}
                  transition={{ duration: 0.2 }}
                >
                  {person.name}
                </motion.h3>
                
                <p className="text-xs uppercase tracking-wider text-[#6B6B6B]">{person.role}</p>

                <motion.div 
                  className="mt-4 space-y-2 border-t border-black/5 pt-4"
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.3 + index * 0.1 }}
                >
                  <motion.a 
                    href={`tel:${person.phone}`} 
                    className="flex items-center gap-2 text-sm text-[#6B6B6B] transition hover:text-[#DA2128]"
                    whileHover={{ 
                      x: 5,
                      color: "#DA2128",
                      transition: { duration: 0.2 }
                    }}
                  >
                    <FiPhone className="text-xs" />
                    {person.phone}
                  </motion.a>

                  <motion.a 
                    href={`mailto:${person.email}`} 
                    className="flex items-center gap-2 break-all text-sm text-[#6B6B6B] transition hover:text-[#DA2128]"
                    whileHover={{ 
                      x: 5,
                      color: "#DA2128",
                      transition: { duration: 0.2 }
                    }}
                  >
                    <FiMail className="text-xs" />
                    {person.email}
                  </motion.a>
                </motion.div>
              </motion.div>
            ))}
          </motion.div>
        </div>

        {/* Footer Note */}
        <motion.div 
          className="mt-2 border-b border-black/5 pt-8 text-center text-m text-[#6B6B6B]"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <p className="mt-2 font-bold">Any dispute/legal case is to be initiated against ASSOCHAM within the jurisdiction of its Registered Office at New Delhi only.</p>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default HelpDeskSection;